import type { ReactNode } from 'react';
import { useFollowSelectorProxy } from '../hooks/use-follow-selector-proxy';
import type { PinItemType } from '~/modules/moodboards/type';

interface FollowSelectorProxyProps {
    pinId: number;
    pinType: PinItemType;
    libraryItemId?: number;
    onFollowChange?: (isFollowed: boolean) => void;
    children: (args: {
        openFollowSelector: (
            eventOrElement?: React.SyntheticEvent<HTMLElement> | HTMLElement,
        ) => void;
    }) => ReactNode;
}

/**
 * Helper component for opening FollowSelector from internally-rendered buttons.
 * Provides an `openFollowSelector` callback and renders the FollowSelector in headless mode.
 *
 * Pass a MouseEvent or HTMLElement to `openFollowSelector` for accurate positioning.
 */
export const FollowSelectorProxy = ({
    pinId,
    pinType,
    libraryItemId,
    onFollowChange,
    children,
}: FollowSelectorProxyProps) => {
    const { followSelector, openFollowSelector } = useFollowSelectorProxy({
        pinId,
        pinType,
        libraryItemId,
        onFollowChange,
    });

    return (
        <>
            {children({ openFollowSelector })}
            {followSelector}
        </>
    );
};
